export type ClassName = string | undefined | null | false;

const classNamesHelper = (classNameArray: Array<ClassName>) => {
  let concatClassName = "";
  classNameArray.forEach((className: ClassName) => {
    if (className) {
      concatClassName += ` ${className}`;
    }
  });
  return concatClassName;
};

export default classNamesHelper;
